import React from "react";

export default function VkBlock() {
  return (
    <section id="vk-block" className="vk-block section section-gradient">
      <div className="container">
        <div className="content-wrapper">
          <h3>Хотите запускать продукты без слива бюджета?</h3>
          <div className="text-content">
            <p>
              На моём <strong>VK</strong>-канале «Ваши идеи - мой код» я делюсь тем, о чём не пишут в учебниках: как проверить идею до старта, как сэкономить на разработке в 2 раза и почему плохое ТЗ - главная причина провала проектов.
            </p>
            <p>
              Подписывайтесь, чтобы получать только практику без воды.
            </p>
          </div>
          <a href="https://vk.com/spaapps" target="_blank" rel="noopener noreferrer" className="btn-primary">
            Подписаться
            <span className="arrow">→</span>
          </a>
        </div>
      </div>

      <style>{`
        /* Стили полностью повторяют блок Principles */
        .vk-block .container {
          max-width: 800px;
        }

        .vk-block .content-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient(135deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.4) 50%, rgba(0, 0, 0, 0.3) 100%);
          backdrop-filter: blur(15px);
          border: 2px solid #60a5fa;
          border-radius: 24px;
          padding: 3rem;
        }

        .vk-block h3 {
          font-size: 2rem;
          font-weight: 800;
          color: #ffffff;
          margin-bottom: 2rem;
          text-align: center;
          letter-spacing: -0.02em;
        }

        .vk-block .text-content {
          margin-bottom: 2.5rem;
        }

        .vk-block p {
          font-size: 1.05rem;
          color: #e2e8f0;
          line-height: 1.8;
          margin-bottom: 1.5rem;
          text-align: left;
        }

        .vk-block p:last-of-type {
          margin-bottom: 0;
        }

        .vk-block strong {
          color: #2575fc;
          font-weight: 700;
          position: relative;
          padding: 0 0.2rem;
        }

        .vk-block a.btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          margin: 0 auto;
          padding: 1rem 2.5rem;
          font-size: 1.05rem;
          font-weight: 700;
          color: white;
          background: #2575fc;
          border-radius: 12px;
          text-decoration: none;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        /* Ховер-эффекты для кнопки */
        .vk-block a.btn-primary::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
        }

        .vk-block a.btn-primary:hover::before {
          left: 100%;
        }

        .vk-block a.btn-primary:hover {
          transform: translateY(-4px);
          box-shadow:
            0 25px 50px rgba(0, 0, 0, 0.4),
            0 0 80px rgba(37, 99, 235, 0.4),
            0 0 120px rgba(96, 165, 250, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
        }

        .vk-block a.btn-primary .arrow {
          transition: transform 0.3s ease;
         font-size: 1.2rem;
        }

        .vk-block a.btn-primary:hover .arrow {
         transform: translateX(4px);
        }

        /* Адаптивность для мобильных устройств */
        @media (max-width: 768px) {
         .vk-block {
            padding: 3rem 0;
         }

         .vk-block .content-wrapper {
           padding: 2rem 1.5rem;
           border-radius: 16px;
         }

         .vk-block h3 {
           font-size: 1.5rem;
           margin-bottom: 1.5rem;
         }

         .vk-block p {
           font-size: 0.95rem;
           margin-bottom: 1.25rem;
         }

         .vk-block a.btn-primary {
           padding: 0.9rem 2rem;
           font-size: 0.95rem;
           width: auto; /* Убрали width:100%, чтобы кнопка была по размеру текста */
           justify-content: center;
         }
       }
      `}</style>
    </section>
    );
}